import styled from "styled-components";

const PagingLink = styled.div`
  font-size: 14px;
  display: block;
  line-height: 1.4;
  color: #333;
`;
export default PagingLink;
